import { render } from "./pageDetails.vue?vue&type=template&id=3a0e1c74"
import script from "./pageDetails.vue?vue&type=script&lang=js"
export * from "./pageDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__